module.exports = __webpack_public_path__ + "static/media/CZE.41cc589d.jpg";